(() => {
  if (!document.querySelector('[data-nv-home-shop]') || window.NVHomeShopping) return;
  document.body.setAttribute('data-nv-home-page','');
  const mobile = window.matchMedia('(max-width: 749px)');
  let buyObserver;
  let frame;
  let navObserver;
  const nearBottom = new Set();
  const shadowStyles = `
    @media(max-width:749px){
      .whatsup-whatsapp-button{width:48px!important;height:48px!important;right:12px!important;bottom:calc(12px + env(safe-area-inset-bottom,0px))!important;z-index:80!important}
      .whatsup-whatsapp-button img{width:100%!important;height:100%!important}
      :host([data-nv-buy-zone]) .whatsup-whatsapp-button,:host([data-nv-menu-open]) .whatsup-whatsapp-button{visibility:hidden!important;pointer-events:none!important}
    }
  `;
  function syncState() {
    const active = mobile.matches && nearBottom.size > 0;
    const nav = document.querySelector('.offcanvas-header');
    const navOpen = !!nav && (nav.classList.contains('open') || nav.classList.contains('active'));
    document.body.classList.toggle('nv-home-buy-zone', active);
    document.body.classList.toggle('nv-home-menu-open', mobile.matches && navOpen);
    document.querySelectorAll('whatsup-whatsapp-button').forEach(host => {
      host.toggleAttribute('data-nv-buy-zone', active);
      host.toggleAttribute('data-nv-menu-open', mobile.matches && navOpen);
    });
  }
  function scanWidgets() {
    document.querySelectorAll('[class^="kl-teaser-"],[class*=" kl-teaser-"]').forEach(node => {
      if (!node.querySelector('form,input,textarea,select')) node.setAttribute('data-nv-compact-teaser','');
    });
    document.querySelectorAll('whatsup-whatsapp-button').forEach(host => {
      if (!host.shadowRoot || host.shadowRoot.querySelector('[data-nv-home-widget-style]')) return;
      const style = document.createElement('style');
      style.setAttribute('data-nv-home-widget-style','');
      style.textContent = shadowStyles;
      host.shadowRoot.appendChild(style);
    });
    syncState();
  }
  function scheduleScan() {
    if (frame) return;
    frame = requestAnimationFrame(() => {frame = 0; scanWidgets();});
  }
  function observePurchases() {
    buyObserver?.disconnect();
    nearBottom.clear();
    if (mobile.matches && 'IntersectionObserver' in window) {
      buyObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {if (entry.isIntersecting) nearBottom.add(entry.target); else nearBottom.delete(entry.target);});
        syncState();
      }, {rootMargin:`-${Math.max(0, window.innerHeight - 92)}px 0px 0px 0px`,threshold:0});
      document.querySelectorAll('[data-nv-home-buy],.nv-home-hero .nv-home-button').forEach(node => buyObserver.observe(node));
    }
    syncState();
  }
  const widgets = new MutationObserver(scheduleScan);
  widgets.observe(document.body,{childList:true,subtree:true});
  const nav = document.querySelector('.offcanvas-header');
  if (nav) {navObserver = new MutationObserver(syncState);navObserver.observe(nav,{attributes:true,attributeFilter:['class']});}
  mobile.addEventListener('change',observePurchases);
  window.addEventListener('resize',observePurchases);
  document.addEventListener('shopify:section:load',() => {observePurchases();scheduleScan();});
  window.NVHomeShopping = {refresh:() => {observePurchases();scheduleScan();}};
  observePurchases();
  scanWidgets();
})();
